var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.role == 'admin' || _vm.role == 'assistant' || _vm.role == 'moderator' || _vm.role == 'super-moderator')?_c('div',[_c('admin')],1):_vm._e(),(_vm.role == 'staff')?_c('div',[_c('staff')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }